export default class Projeto {
    
    constructor(model = null){
        this.id = 0;
        this.empresaId = 0;
        this.nome = '';        
        this.tipoProjetoId = 0;
        this.restricaoRecursos = 'L';
        this.metaBeneficiario = 0;
        // this.dataInicio = '';
        // this.dataTermino = '';
        this.objetivo = '';
        this.frequenciaTipo = '';
        this.frequenciaTipoStr = '';
        this.frequenciaSegunda = false;
        this.frequenciaTerca = false;
        this.frequenciaQuarta = false;
        this.frequenciaQuinta = false;
        this.frequenciaSexta = false;
        this.frequenciaSabado = false;
        this.frequenciaDomingo = false;
        this.cnpjFinanciador = '';
        this.aberto = true;

        if (!model)
            return;
        
        this.id = model.id ? model.id : 0;
        this.empresaId = model.empresaId;
        this.nome = model.nome;
        this.tipoProjetoId = model.tipoProjetoId;
        this.tipoProjeto = model.tipoProjeto;
        this.restricaoRecursos = model.restricaoRecursos || 'L';
        this.metaBeneficiario = model.metaBeneficiario;
        this.dataInicio = new Date(model.dataInicio).yyyymmdd();
        this.dataTermino = model.dataTermino ? new Date(model.dataTermino).yyyymmdd() : '';
        this.objetivo = model.objetivo;
        this.frequenciaTipo = model.frequenciaTipo;
        this.frequenciaTipoStr = model.frequenciaTipoStr;
        this.frequenciaSegunda = model.frequenciaSegunda;
        this.frequenciaTerca = model.frequenciaTerca;
        this.frequenciaQuarta = model.frequenciaQuarta;
        this.frequenciaQuinta = model.frequenciaQuinta;
        this.frequenciaSexta = model.frequenciaSexta;
        this.frequenciaSabado = model.frequenciaSabado;
        this.frequenciaDomingo = model.frequenciaDomingo;
        this.cnpjFinanciador = model.cnpjFinanciador;
        this.aberto = model.aberto;

        this.beneficiarios = model.beneficiarios;
        this.atividades = model.atividades;
        this.pessoais = model.pessoais;
    }
}
